import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 全局错误处理 - 捕获脚本错误，防止应用崩溃
window.addEventListener('error', (event) => {
  // 捕获所有脚本错误，特别是外部脚本（如高德地图API）
  const errorMessage = event.message || '';
  const errorSource = event.filename || '';
  
  // 如果是外部脚本错误或高德地图相关错误，只记录日志，不阻止应用运行
  if (
    errorMessage.includes('Script error') ||
    errorMessage.includes('AMap') ||
    errorSource.includes('amap.com') ||
    errorSource.includes('webapi.amap.com')
  ) {
    // 检查是否是USERKEY_PLAT_NOMATCH错误
    if (errorMessage.includes('USERKEY_PLAT_NOMATCH') || errorMessage.includes('平台类型不匹配')) {
      console.warn('高德地图API Key平台类型不匹配:', {
        message: '请确保API Key类型为「Web 端（JS API）」',
        solution: '登录 https://console.amap.com/ 检查Key配置，确保选择「Web 端（JS API）」',
        source: errorSource
      });
    } else {
      console.warn('外部脚本错误（已忽略）:', {
        message: errorMessage,
        source: errorSource,
        lineno: event.lineno,
        colno: event.colno
      });
    }
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
  
  // 其他错误正常处理
  return true;
}, true); // 使用捕获阶段

// 捕获未处理的Promise拒绝
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason?.message || event.reason;
  
  // 如果是高德地图相关的Promise错误，忽略
  if (
    reason?.includes('AMap') ||
    reason?.includes('amap.com') ||
    reason?.includes('Script error')
  ) {
    console.warn('外部脚本Promise错误（已忽略）:', reason);
    event.preventDefault();
    return;
  }
  
  console.warn('未处理的Promise拒绝:', reason);
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
